export default "__VITE_ASSET__DkrDmkuu__"